import { useContext, useState } from "react";
import ConfirmDialog from "../components/shared/ConfirmDialog";
import { DROP_BOOKING } from "../gql/bookingapi";
import { useSelector } from "react-redux";
import { withApollo } from "react-apollo";
import { PaginationContext } from "../components/shared/pagination/PaginationContext";

const handleRejectFactory = async ({ client, user, reasonValue, force, item, setStatus, dispatchAction }) => {
    try {
        setStatus(true);
        await client.mutate({
            mutation: DROP_BOOKING,
            variables: {
                createdBy: user.user,
                remark: reasonValue,
                force: force,
                bookingId: item,
            },
        });
    } catch (e) {
        setStatus(false);
        dispatchAction({
            type: "clearAll",
        });
    }
};

const RejectBooking = ({
    client,
    setIsRejectBooking,
    setIsRejectDialogOpen,
    isRejectDialogOpen = false,
    force = false,
    item,
    status,
    setStatus,
}) => {
    const [reasonValue, setReasonValue] = useState(null);
    const user = useSelector((store) => store.user);
    const { dispatchAction } = useContext(PaginationContext);

    const handlerOnRejectBooking = async () => {
        dispatchAction({
            type: "fetching",
            payload: true,
        });
        handleRejectFactory({
            client,
            user,
            reasonValue,
            force,
            item,
            setStatus,
            dispatchAction,
        });
        setReasonValue("");
    };

    const onReasonChanged = (reason) => {
        setReasonValue(reason);
    };

    const handleOnclose = () => {
        setIsRejectBooking(false);
        setIsRejectDialogOpen(false);
        setReasonValue("");
        return true;
    };

    const handlerOnCancelRejectBooking = () => {
        setIsRejectBooking(false);
        setIsRejectDialogOpen(false);
        setReasonValue("");
    };

    return (
        <ConfirmDialog
            approveText="Reject"
            approveColor="primary"
            approveVariant="contained"
            cancelText="Cancel"
            cancelVariant="outlined"
            cancelColor="primary"
            onApprove={() => handlerOnRejectBooking()}
            title="Reject booking"
            content={`Are you sure you want to reject this booking?`}
            showReasonDD={true}
            reasonValue={reasonValue}
            onReasonChanged={onReasonChanged}
            disableBooking={!reasonValue}
            close={handleOnclose}
            open={isRejectDialogOpen}
            onCancel={handlerOnCancelRejectBooking}
            fullWidth={false}
            maxWidth="sm"
            reasonDropdowmLabel={`Please add reason for rejecting booking`}
            loading={status}
        />
    );
};

export default withApollo(RejectBooking); 